import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Box, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useField, useFormikContext } from 'formik';
import { SwitchField } from 'shared/domains/forms';
import { SwitchFieldContainer } from './styled';
export function PromptVisibility(props) {
    const { disabled } = props;
    const { isSubmitting } = useFormikContext();
    const [field, , helpers] = useField({
        name: 'isPublic',
        type: 'checkbox',
    });
    const checked = Boolean(field.checked);
    const checkedLabel = t({
        message: 'Public',
        comment: 'Prompt public field text to toggle public prompt',
    });
    const uncheckedLabel = t({
        message: 'Private',
        comment: 'Prompt public field text to toggle private prompt',
    });
    return (<SwitchFieldContainer>
      <SwitchField title={t({
            message: 'Prompt visibility',
            comment: 'Prompt public field text to toggle public prompt',
        })} subtitle={t({
            message: 'If the prompt should be private to you or visible to everyone in your company',
            comment: 'Prompt public field text to toggle public prompt',
        })} icon={checked ? <Falcon icon="eye"/> : <Falcon icon="eye-slash"/>} label={checked ? checkedLabel : uncheckedLabel} checked={checked || false} disabled={isSubmitting || disabled} onCheckedChange={(nextValue) => helpers.setValue(nextValue)}/>

      {disabled && (<Box bg="background.75" p="md" borderRadius="md">
          <Typography $fontSize="tiny" $appearance="100">
            <Trans comment="Prompt library - Public field information">Only owners can set a prompt as public.</Trans>
          </Typography>
        </Box>)}
    </SwitchFieldContainer>);
}
